/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable indent */
/* eslint-disable operator-linebreak */
/* eslint-disable import/prefer-default-export */

import { GameBookTemplateValues } from '@orientaction/types';
import { AppThunk } from '../store';

export const updateField =
  (field: string, value: unknown): AppThunk =>
  (dispatch) => {
    dispatch({
      type: 'UPDATE_FIELD',
      payload: { field, value },
    });
  };

export const resetValues = (): AppThunk => (dispatch) => {
  dispatch({
    type: 'RESET_VALUES',
  });
};

export const setAllValues =
  (payload: Partial<GameBookTemplateValues>): AppThunk =>
  (dispatch) => {
    dispatch({
      type: 'SET_ALL_VALUES',
      payload,
    });
  };
